import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_EMAIL_UPDATE = 'REQUEST_EMAIL_UPDATE'
export const doREQUEST_EMAIL_UPDATE = createDoRequestAction(REQUEST_EMAIL_UPDATE)

export const requestEmailUpdateActionCreators = {
  doREQUEST_EMAIL_UPDATE,
}

export function* requestEmailUpdate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestEmailUpdate')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_EMAIL_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-email-update-request`,
    accessToken,
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_EMAIL_UPDATE,
          requestId: payload.requestId,
          fromPayload: payload,
          url: '/v1/web/identity-email-update-request',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  return yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_EMAIL_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* requestEmailUpdateSaga() {
  yield takeEvery(REQUEST_EMAIL_UPDATE, requestEmailUpdate)
}
